import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from 'redux-form';
import {Actions} from '../../../common/actions';
import {MASTER_VEHICLE_FORM} from '../../../common/forms';
import {Button, Card, Form, Tab, Icon, Dimmer, Loader} from 'semantic-ui-react';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {vehicleMasterRequestStatus} from '../../../common/constants/lists';
import ProductData from './tabs/productData';
import ServiceData from './tabs/serviceData';
import ImportData from './tabs/importData';
import SalesData from './tabs/salesData';
import ModalReject from './modals/modalReject';
import Audit from './modals/audit';
import {cloneDeep, omitBy, isEqual} from 'lodash';
import {toFloatDecimals} from '../../../common/util/fieldsNormalization';

const panes = [
  {'menuItem': 'Producto'},
  {'menuItem': 'Ventas'},
  {'menuItem': 'Servicio'},
  {'menuItem': 'Importaciones'},
];

const PANES_INDICES = {
  'PRODUCT': 0,
  'SALES': 1,
  'SERVICE': 2,
  'IMPORT': 3,
};

class masterVehicleForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'typeOfSubmit': '',
      'addProduct': props.principalState === vehicleMasterRequestStatus[0].text.toUpperCase() &&
        hasAccessPermission(props.permissions, resources.MasterVehicleManage, scopes.ProductEdit),
      'addSales': props.principalState === vehicleMasterRequestStatus[1].text.toUpperCase() &&
        hasAccessPermission(props.permissions, resources.MasterVehicleManage, scopes.SalesEdit),
      'addService': props.principalState === vehicleMasterRequestStatus[2].text.toUpperCase() &&
        hasAccessPermission(props.permissions, resources.MasterVehicleManage, scopes.ServiceEdit),
      'addImport': props.principalState === vehicleMasterRequestStatus[3].text.toUpperCase() &&
        hasAccessPermission(props.permissions, resources.MasterVehicleManage, scopes.ImportationsEdit),
      'filess': [],
    };
  }

  componentDidMount() {
    const {permissions, code} = this.props;

    if (!(hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ProductEdit) ||
      hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.SalesEdit) ||
      hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ServiceEdit) ||
      hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ImportationsEdit))) {
      this.props.push(paths.AccessDenied);
      return;
    }
    this.props.deleteMasterVEHData();
    this.props.fetchJDEParameters();
    this.props.fetchVehiclesModel();
    this.props.fetchClassesWithSubclasses();
    if (code) {
      this.props.fetchMasterVEH(code);
      this.props.fetchMasterVEHColor(code);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {principalState, permissions} = this.props;
    if (prevProps.principalState === principalState) {
      return;
    }
    if (principalState === 'JDE' &&
      hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ProductEdit)) {
      this.props.changeRequestState('PRODUCTO');
    }
    this.setState({
      'addProduct': principalState === vehicleMasterRequestStatus[0].text.toUpperCase() &&
        hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ProductEdit),
      'addSales': principalState === vehicleMasterRequestStatus[1].text.toUpperCase() &&
        hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.SalesEdit),
      'addService': principalState === vehicleMasterRequestStatus[2].text.toUpperCase() &&
        hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ServiceEdit),
      'addImport': (principalState === vehicleMasterRequestStatus[3].text.toUpperCase() ||
      principalState === vehicleMasterRequestStatus[4].text.toUpperCase()) &&
        hasAccessPermission(permissions, resources.MasterVehicleManage, scopes.ImportationsEdit),
    });
  }

  changeTabIndex(event, data) {
    this.setState({'activeTabIndex': data.activeIndex});
  }

  onCancelClick() {
    this.props.goBack();
  }

  clearForm() {
    const {reset, code} = this.props;
    reset();
    if (code) {
      this.props.fetchMasterVEH(code);
      this.props.fetchMasterVEHColor(code);
      return;
    }
    this.props.changeRequestState('PRODUCTO');
  }

  getVehicleName() {
    const {code, katashiki, sfxTde} = this.props;
    if (!code) {
      return '';
    }
    const katashikiName = katashiki ? `/${katashiki}` : '';
    return `${sfxTde}${katashikiName}`;
  }

  render() {
    const {loading, submitting, handleSubmit, code, principalState, katashiki, sfxTde} = this.props;
    const {addProduct, addSales, addService, addImport} = this.state;
    const isDisabled = loading || submitting || !(addProduct || addSales || addService || addImport);
    return (
      <Form
        className='vehicle-master-form'
        loading={submitting}
        onSubmit={handleSubmit(this.onSubmit.bind(this))}
        autoComplete='off'
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>{code ? 'Editar' : 'Agregar'} Modelo Vehículo {this.getVehicleName()} - {principalState}</h2>
              <div className='title-bar-actions'>
                <Button secondary type='button'
                  onClick={this.onCancelClick.bind(this)}
                >
                  Cancelar
                </Button>
                {code && <Audit code={code} katashiki={katashiki} sfx={sfxTde} />}
                <Button primary type='submit' disabled={isDisabled}
                  onClick={this.changeTypeOfSubmit.bind(this, 'SAVE')}
                >
                  Guardar
                </Button>
                <Button primary type='submit' disabled={isDisabled || !code}
                  onClick={this.changeTypeOfSubmit.bind(this, 'SEND')}
                >
                  Enviar
                </Button>
                <ModalReject code={code} disabled={isDisabled} rejectRequest={this.changeTypeOfSubmit.bind(this)} />
              </div>
            </div>
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            activeIndex={this.state.activeTabIndex}
            onTabChange={this.changeTabIndex.bind(this)}
          />
        </Card>
        
        {this.renderLoader()}

        {this.renderPanesContent()}
      </Form>
    );
  }

  renderLoader() {
    const {loading, loadingColors, loadingJdeParameters, saving} = this.props;
    if (loading || loadingColors || loadingJdeParameters) {
      return (
        <Dimmer active inverted>
          <Loader inverted inline='centered' content='Cargando' />
        </Dimmer>
      );
    }
    if (saving) {
      return (
        <Dimmer active inverted>
          <Loader inverted inline='centered' content={this.getAction()} />
        </Dimmer>
      );
    }
    return null;
  }

  getAction() {
    const {typeOfSubmit} = this.state;
    switch (typeOfSubmit) {
      case 'SAVE':
        return 'Guardando';
      case 'SEND':
        return 'Actualizando';
      case 'REJECT':
        return 'Rechazando Solicitud';
      default:
        return '';
    }
  }

  changeTypeOfSubmit(type) {
    this.setState({
      'typeOfSubmit': type,
    });
  }
  // eslint-disable-next-line max-statements
  onSubmit(formValues) {
    const {code} = this.props;
    const {typeOfSubmit} = this.state;
    const valuesChanged = this.getValuesChanged(formValues);
    const valuesChangedKeys = Object.keys(valuesChanged);
    const {filess, addService} = this.state;
    const formData = this.processFiles(filess);
    const valuesChangedFormatted = Object.fromEntries(new Map(valuesChangedKeys.map((x) => {
      return [x, typeof valuesChanged[x] === 'string' ? toFloatDecimals(valuesChanged[x]) : valuesChanged[x]];
    })));

    if (!('esGoshi' in valuesChangedFormatted)) {
      valuesChangedFormatted.esGoshi = formValues.esGoshi === true ? true : false;
    }

    if (!code) {
      this.props.createMasterVEH(valuesChangedFormatted);
      this.props.goBack();
      return;
    }

    switch (typeOfSubmit) {
      default:
        break;
      case 'SAVE':
        this.props.updateMasterVEH(code, typeOfSubmit, valuesChangedFormatted);
        if (addService) {
          this.props.saveVehicleFile(code, code, formData);
        }
        break;
      case 'SEND':
        valuesChangedFormatted.state = this.getNextState();
        if (addService) {
          this.props.saveVehicleFile(code, code, formData);
        }
        this.props.updateMasterVEH(code, typeOfSubmit, valuesChangedFormatted);
        this.props.goBack();
        break;
    }
  }

  getValuesChanged(formValues) {
    const {initialValues, initialColors} = this.props;

    const newValues = cloneDeep(formValues);
    delete newValues.colorList;
    const newColors = cloneDeep(formValues.colorList);

    const diff = omitBy(newValues, (v, k) => {
      return initialValues[k] === v;
    });
    if (!isEqual(newColors, initialColors)) {
      diff.colorList = newColors;
    }
    return diff;
  }
  processFiles = (files) => {
    const formData = new FormData();
    files.forEach((element, index) => {
      const name = element.name;
      formData.append('file', element, name);
    });
    return formData;
  };
  handleChangeImages = (files) => {
    const {setImageAttachments} = this.props;
    this.setState({
      'filess': files.map((fileItem) => {
        return fileItem.file;
      }),
    });
    const fileItems = files.map((fileItem) => fileItem.file);
    setImageAttachments(fileItems);
  };
  getNextState() {
    const {principalState} = this.props;
    if (principalState === 'PRODUCTO') {
      return 'VENTAS';
    }
    if (principalState === 'VENTAS') {
      return 'SERVICIO';
    }
    if (principalState === 'SERVICIO') {
      return 'IMPORTACIONES';
    }
    if (principalState === 'IMPORTACIONES') {
      return 'JDE';
    }
  }

  renderPanesContent() {
    const {activeTabIndex, addProduct, addSales, addService, addImport} = this.state;
    switch (activeTabIndex) {
      default:
      case PANES_INDICES.PRODUCT:
        return <ProductData {...this.props} addProduct={addProduct} />;
      case PANES_INDICES.SALES:
        return <SalesData {...this.props} addSales={addSales} />;
      case PANES_INDICES.SERVICE:
        return <ServiceData {...this.props} addService={addService} handleChangeImages={this.handleChangeImages}
          addImport={addImport}/>;
      case PANES_INDICES.IMPORT:
        return <ImportData {...this.props} addImport={addImport} />;
    }
  }
}

export {masterVehicleForm};

const form = reduxForm({
  'form': MASTER_VEHICLE_FORM.name,
  'destroyOnUnmount': false,
})(masterVehicleForm);

const mapStateToProps = (state, ownProps) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const principalState = formValues(state, 'state');
  const katashiki = formValues(state, 'katashiki');
  const sfxTde = formValues(state, 'sfx');
  const filesCharge = formValues(state, 'filesCharge');
  return {
    'initialValues': state.form.masterVehicle.initialValues,
    'initialColors': state.form.masterVehicle.initialColors,
    'code': ownProps.params.vehCode,
    'loadingJdeParameters': state.masterVehicle.jdeLoading,
    'loadingColors': state.form.masterVehicle.loadingColors,
    'loading': state.form.masterVehicle.loading,
    'saving': state.form.masterVehicle.saving,
    principalState,
    katashiki,
    sfxTde,
    'goBack': ownProps.history.goBack,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'images': state.masterVehicleImages.images,
    filesCharge,
  };
};

const {
  deleteMasterVEHData,
  fetchMasterVEH,
  fetchMasterVEHColor,
  fetchJDEParameters,
  fetchVehiclesModel,
  fetchClassesWithSubclasses,
  changeRequestState,
  createMasterVEH,
  updateMasterVEH,
  withRouter,
  saveVehicleFile,
  getMasterVehicleImages,
  setImageAttachments,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  deleteMasterVEHData,
  fetchMasterVEH,
  fetchMasterVEHColor,
  fetchJDEParameters,
  fetchVehiclesModel,
  fetchClassesWithSubclasses,
  changeRequestState,
  createMasterVEH,
  updateMasterVEH,
  saveVehicleFile,
  getMasterVehicleImages,
  setImageAttachments,
})(form));
